<script>
function renderSelect(vm, h, { fieldset, values } = {}){
  const isSub = !!fieldset.subs
  const optionsEl =
    ( isSub ? fieldset.subs : fieldset.options )
    .map((item, index)=>{
      return <iv-option
        class="text-left"
        key={ item.id+'-'+index }
        {...{
          props: {
            label: item.name,
            value: item.id,
          }
        }}>
        { item.title || item.name }
      </iv-option>
    })
  return <iv-select
    { ...{
      style: (isSub ? fieldset.search_by_style : fieldset.style) || {width: '80px'},
      props: {
        value: isSub ? values[fieldset.search_by] : values[fieldset.name],
        multiple: fieldset.multiple,
        placeholder: fieldset.placeholder,
        filterable: fieldset.filterable,
        clearable: fieldset.clearable,
        size: vm.$props.size,
        disabled: fieldset.disabled,
      },
      on: { 'on-change': $event=> isSub ? vm.clearOtherSub(fieldset) : vm.onValueChanged($event, fieldset.name) }
    } }>
    { optionsEl }
  </iv-select>
}
function renderInput(vm, h, { fieldset, values } = {}){
  const isSub = !!fieldset.subs
  const titleEl = <span>{ fieldset.title || fieldset.name }</span>;
  return <iv-input
    { ...{
      style: (isSub ? fieldset.search_by_style : fieldset.style) || {width: '80px'},
      props: {
        value: isSub ? values[fieldset.search_by] : values[fieldset.name],
        size: vm.$props.size,
        placeholder: fieldset.placeholder
      },
      on: {
        input: $event => vm.onValueChanged($event, fieldset.name),
        keypress: $event=>{
          if($event.code!='enter') return
          vm.$emit('search')
          $event.preventDefault()
          $event.stopPropagation()
        }
      }
    } }>
    <span slot="prepend">{ titleEl }{ isSub ? renderSelect(vm, h, { fieldset, values }) : "" }</span>;
  </iv-input>
}
function renderButtonGroup(vm, h, { fieldset, values } = {}){
  const isSub = !!fieldset.subs
  const buttons =
    (isSub ? fieldset.subs : fieldset.options)
    .map((item, index)=>{
      return <iv-button
        {...{
          props: {
            key: index,
            size: vm.$props.size,
            type: 'primary',
            ghost: !(isSub ? values[fieldset.name] == item.name : values[fieldset.name] == item.id)
          },
          on: {
            click: ()=> isSub ? vm.onButtonGroupChanged(fieldset, item) : vm.onValueChanged(item.id, fieldset.name)
          }
        }}
      >
      { typeof item.icon != "undefined" ? <iv-icon type={item.icon} /> : "" }
      { item.title || item.name }
      </iv-button>
    })
  return <iv-button-group {...{
    style: fieldset.style
  }}>{ buttons }</iv-button-group>
}
function renderDatePicker(vm, h, { fieldset, values } = {}, type='date'){
  const _type = type
  return <iv-date-picker {...{
    props: {
      type: _type,
      format: fieldset.format || 'yyyy-MM-dd',
      placeholder: fieldset.placeholder,
      value: vm.conditions.values[fieldset.name],
      size: vm.$props.size
    },
    style: fieldset.style || {width: fieldset.hasTimer ? '280px' : '200px'},
    on: {
      input: $event=>{
        vm.onValueChanged($event, fieldset.name)
        if(_type != 'date') vm.onDaterangeChanged(fieldset)
      },
      //  onChange: $event=>{

      //   vm.onValueChanged($event, fieldset.name)
      //   if(_type != 'date') vm.onDaterangeChanged(fieldset)
      // }
    }
  }}/>
}

const builder = {
  renderSelect,
  renderInput,
  renderButtonGroup,
  renderDate: (...args)=>renderDatePicker(...args, "date"),
  renderDaterange: (...args)=>renderDatePicker(...args, "daterange"),
  renderMonth: (...args)=>renderDatePicker(...args, "month"),
}
export default {
  render(h) {

    function getRenderFun(name, builder){
        return builder[name] ? builder[name] : ()=>{}
    }

    function _render(vm, conditions, values, builder){
      return conditions.map(fieldset=>{
        return fieldset.hidden ? "" : <iv-form-item prop={fieldset.name} key={fieldset.name}>
          { getRenderFun('render'+fieldset.type, builder)(vm, h, { fieldset, values }) }
        </iv-form-item>
      })
    }

    return (
      <iv-form
        class="adm-filterbar"
        {...{
          props: {
            value: this.conditions.values,
            inline: this.inline,
            labelPosition: this.labelPosition,
            labelWidth: this.labelWidth
          }
        }}
      >
        {this.$slots.before}
        { _render(this, this.conditions.attrs, this.conditions.values, this.builders) }
        {this.$slots.default}
      </iv-form>
    );
  },

  props: {
    value: Object,
    condition: Array,
    inline: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: "right"
    },
    labelWidth: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: "default"
    },
    builder: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  beforeMount() {
    if (!!this.condition) this.mapCondition(this.condition);
  },
  data() {
    return {
      conditions: {
        attrs: this.condition || [],
        values: this.value || {}
      },
      builders: { ...builder, ...this.builder }
    };
  },
  watch: {
    value(val) {
      this.conditions.values = val
      this.updateSubs()
    },
    condition(val) {
      this.mapCondition(val);
    },
    builder(val){
      if(!val) return
      this.builders = { ...builder, ...val }
    }
  },
  methods: {
    clearOtherSub(fieldset){
      fieldset.subs
        .filter(sub => sub.name != this.conditions.values[fieldset.name])
        .forEach(sub => (this.conditions.values[sub.name] = ""));
    },
    updateSubs({ attrs, values } = this.conditions){
      attrs
        .filter(item => ["Select", "ButtonGroup"].indexOf(item.type))
        .filter(item => !!item.subs)
        .forEach(item =>
          item.subs
            .filter(sub => sub.name == values[item.name])
            .forEach(sub => this.onButtonGroupChanged(item, sub))
        );
    },
    mapCondition(val) {
      // 格式化subs数据，转为对应的fiedlset
      this.conditions.attrs = val.map(fieldset => {
        if (
          !!fieldset.subs &&
          fieldset.subs.every(sub => typeof sub == "string")
        ) {
          fieldset.subs = fieldset.subs.map(fieldName =>
            this.conditions.attrs.find(fieldset => fieldset.name == fieldName)
          );
        }
        return fieldset;
      });

      this.updateSubs()
      this.conditions.values = this.conditions.values;
    },
    onButtonGroupChanged(fieldset, item) {
        fieldset.subs.forEach(sub => sub.hidden = sub.name != item.name);
        this.onValueChanged(item.name, fieldset.name)
        this.clearOtherSub(fieldset);
    },
    onDaterangeChanged(fieldset) {
      if (typeof fieldset.subs === "undefined") return;
      this.$nextTick(() => {
        fieldset.subs.forEach(
          (index, sub_fieldset) =>
            (this.conditions.values[sub_fieldset.name] = this.conditions.values[
              fieldset.name
            ][index])
        );
      });
    },
    onValueChanged(val, fieldName) {
      this.conditions.values[fieldName] = val;
      this.$emit("input", this.conditions.values)
      this.$emit("change", {fieldName, value:val, conditions: this.conditions.values})
    }
  }
};
</script>
